/**
 * EVProjectHeader - Project name with rename and delete buttons
 */

import React, { useState } from 'react';
import {
    Box,
    Typography,
    Button,
    IconButton,
    TextField,
} from '@mui/material';
import { Edit as EditIcon, Check as CheckIcon, Close as CloseIcon } from '@mui/icons-material';
import { useThemeMode, vortxColors, vortxTypography, SaveStatusIndicator } from '@vortx/shared-ui';

function EVProjectHeader({ project }) {
    const { mode } = useThemeMode();
    const isRetro = mode === 'retro';
    const [isEditing, setIsEditing] = useState(false);
    const [editName, setEditName] = useState('');

    const handleStartEdit = () => {
        setEditName(project.currentProject?.name || '');
        setIsEditing(true);
    };

    const handleSaveEdit = () => {
        if (editName.trim() && editName !== project.currentProject?.name) {
            project.renameProject(editName.trim());
        }
        setIsEditing(false);
    };

    const handleCancelEdit = () => {
        setIsEditing(false);
        setEditName('');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSaveEdit();
        } else if (e.key === 'Escape') {
            handleCancelEdit();
        }
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            {isEditing ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, mr: 2 }}>
                    <TextField
                        value={editName}
                        onChange={(e) => setEditName(e.target.value)}
                        onKeyDown={handleKeyPress}
                        size="small"
                        autoFocus
                        fullWidth
                        sx={{ maxWidth: 400 }}
                    />
                    <IconButton size="small" onClick={handleSaveEdit} color="primary">
                        <CheckIcon />
                    </IconButton>
                    <IconButton size="small" onClick={handleCancelEdit}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontFamily: vortxTypography.heading,
                            color: isRetro ? vortxColors.gold : 'text.primary',
                        }}
                    >
                        {project.currentProject?.name || 'EV Project'}
                    </Typography>
                    <IconButton size="small" onClick={handleStartEdit}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                    <SaveStatusIndicator
                        status={project.saveStatus}
                        error={project.saveError}
                        lastSavedAt={project.lastSavedAt}
                    />
                </Box>
            )}
            <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={() => project.deleteProject()}
            >
                Delete
            </Button>
        </Box>
    );
}

export default EVProjectHeader;
